import { useState, useEffect } from 'react'
import { Typography, Box } from '@material-ui/core'

const CurrentBankingAmount = ({ bankingHistoryData }) => {
  const [currentAmount, setCurrentAmount] = useState(0)
  const [iban, setIban] = useState('')

  useEffect(() => {
    if (bankingHistoryData) {
      if (bankingHistoryData.balanceCents) {
        setCurrentAmount(bankingHistoryData.balanceCents / 100)
      }
      if (bankingHistoryData.iban) {
        setIban(bankingHistoryData.iban)
      }
    }
  }, [bankingHistoryData])

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      style={{ marginBottom: '25px' }}
    >
      <Typography variant="h5" style={{ marginBottom: '10px' }}>
        Montant actuel du compte : <b>{currentAmount} €</b>
      </Typography>
      <Typography variant="body1" style={{ marginBottom: '35px' }}>
        IBAN : {iban}
      </Typography>
    </Box>
  )
}

export default CurrentBankingAmount
